import { makeApi } from "@zodios/core";
import { z } from "zod";

export const tokenResponseSchema = z.object({
  access_token: z.string().min(1),
  refresh_token: z.string().min(1),
  expires_in: z.number(),
});

export const backofficeExternalLoginApi = makeApi([
  {
    method: "post",
    path: "/token",
    response: tokenResponseSchema,
    alias: "externalLogin",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          username: z.string().min(1),
          password: z.string().min(1),
        }),
      },
    ],
  },
]);
